import React from "react";
import { Link, useLocation } from "react-router-dom";
import Datalayer from "../../services/datalayer";
import CTAButton from "../CTAButton";
import DefaultThumb from "../../assets/images/default_thumb_banner.png";
import * as S from "./style";

export const Banner = ({ content = [] }) => {
  const { search } = useLocation();

  const { courses } = content.length > 0 && content[0];
  const { images } = !!courses && courses.length > 0 && courses[0];
  const coverImage = (!!images && images.coverUrl) || DefaultThumb;

  return (
    <S.Wrapper backgroundImage={coverImage}>
      <S.OverlayContainer>
        <S.BannerTextContainer>
          <S.BannerTitle>7 dias de garantia</S.BannerTitle>
          <S.BannerText className={"banner-title"}>
            A partir de R$ 39,90 mensais, você tem acesso ilimitado a mais de
            300 cursos originais.
          </S.BannerText>
        </S.BannerTextContainer>

        <Link
          to={{
            pathname: "/signup",
            search,
          }}
        >
          <CTAButton
            small
            onClick={() =>
              Datalayer.onClick("checkout", "assine-agora", "app-explore")
            }
            id={"btn-banner_signin-assine_agora"}
            name={"btn-banner_signin-assine_agora"}
            text={"ASSINE AGORA"}
          />
        </Link>
      </S.OverlayContainer>
    </S.Wrapper>
  );
};

export default Banner;
